// Broken-image safety net. If an external image fails to load, swap to a neutral
// sports-travel fallback so pages never show a broken image icon.
export const FALLBACK_IMG =
  "https://images.unsplash.com/photo-1782130056357-3339bb395a7a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export function onImgError(e) {
  const el = e.currentTarget;
  if (el.dataset.fallbackApplied) return;
  el.dataset.fallbackApplied = "1";
  el.src = FALLBACK_IMG;
}
